import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useAppState } from "../../state";
import { usePrevState } from "../../context/PrevStateProvider";

export default function PrivateRoute({
  children,
  redirectTo = "/become-a-member",
  ...rest
}) {
  const { hasTriedToAutoLogin, user } = useAppState();
  const { prevState } = usePrevState();

  const renderChildren = !!user;

  if (!renderChildren && !hasTriedToAutoLogin) {
    return null;
  }

  return (
    <Route
      {...rest}
      render={({ location }) =>
        renderChildren ? (
          React.cloneElement(children, { prevState })
        ) : (
          <Redirect
            to={{
              pathname: `${redirectTo}`,
              search: `?return_to=${encodeURIComponent(
                `${location.pathname}${location.search}`
              )}`,
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}
